export default "__VITE_ASSET__a4268d10__"